"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deprecateConstructorEntries = void 0;
const util_1 = require("util");
exports.deprecateConstructorEntries = (0, util_1.deprecate)(() => { }, "Constructor \"entries\" argument is not spec-compliant "
    + "and will be removed in next major release.");
